import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import { publicRoutes } from "../pages/public";
import { protectedRoutes } from "../pages/protected";
import Login from "../pages/public/login";
import NotFound from "../pages/public/notFound";

type AppRoutesProps = {
  isAuthenticated: boolean;
  isAuthRequired: boolean;
};

export const AppRoutes = ({
  isAuthenticated,
  isAuthRequired,
}: AppRoutesProps) => {
  let routes: RouteObject[] = [];

  if (isAuthRequired && !isAuthenticated) {
    routes = [
      { path: "/login", element: <Login /> },
      { path: "*", element: <Navigate to="/login" replace /> },
    ];
  } else {
    routes = [
      ...publicRoutes,
      ...protectedRoutes,
      {
        path: "/login",
        element: isAuthRequired ? (
          <Navigate to="/user-list" replace />
        ) : (
          <Login />
        ),
      },
      { path: "/not-found", element: <NotFound /> },
      { path: "*", element: <Navigate to="/not-found" replace /> },
    ];
  }

  const element = useRoutes(routes);
  return <>{element}</>;
};
